/**
 * The five milestones a partner's own website can listen for.
 *
 * SCREAMING_SNAKE to match EDisplays and EModals. This is a published
 * contract: partner sites switch on these strings, and the integration guide
 * on the youX website names them. They are not ours to rename.
 *
 * Deliberately NOT the internal behavioural tracking taxonomy, which is
 * camelCase, posts to our own API and changes whenever we need it to.
 */
export enum EJourneyEvent {
    TOOL_ENGAGED = 'TOOL_ENGAGED',
    LEAD_CAPTURED = 'LEAD_CAPTURED',
    CREDIT_CHECKED = 'CREDIT_CHECKED',
    LENDERS_PRESENTED = 'LENDERS_PRESENTED',
    JOURNEY_COMPLETED = 'JOURNEY_COMPLETED',
}

/** The envelope. No identifiers, no personal data, no redirect URL. */
export interface IJourneyEventMessage {
    source: 'youx-apply';
    version: 1;
    event: EJourneyEvent;
}

export const JOURNEY_EVENT_SOURCE = 'youx-apply';
export const JOURNEY_EVENT_VERSION = 1;
